import {
  Component,
  OnInit,
  ViewEncapsulation,
  AfterViewInit
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import * as bookingActions from '../../../store/actions/booking.action';
import * as confirmationActions from '../../../store/actions/confirmation.action';
import { map } from 'rxjs/operators';
import { PaymentService } from '../../services/payment.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'app-booking-list',
  templateUrl: './booking-list.component.html',
  styleUrls: ['./booking-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class BookingListComponent implements OnInit, AfterViewInit, OnDestroy {
  bookings$: Observable<any>;
  paidForConference$: Observable<boolean>;
  paidForAccommodation$: Observable<boolean>;
  isAdmin: boolean;

  admins = ['jlandzro@gmail.com', 'enoch@abassey.com'];
  columns = [{ prop: 'firstNames' }, { name: 'Booking Price' }];
  adminSubscription: Subscription;
  constructor(
    private readonly store: Store<State>,
    private router: Router,
    private authService: AuthService,
    private paymentService: PaymentService
  ) {
    store.dispatch(new bookingActions.GetBookings());
  }

  ngOnInit() {
    this.bookings$ = this.store.select(state => state.booking.bookings);
    this.paymentService.checkAccommodationPayment();
    this.paymentService.checkConferencePayment();
    this.paidForConference$ = this.store.select(
      state => state.payment.paidForConference
    );
    this.paidForAccommodation$ = this.store.select(
      state => state.payment.paidForAccommodation
    );

    // this.authService.user
    //   .pipe(
    //     map(auth => {
    //       return this.admins.includes(auth.email);
    //     })
    //   )
    //   .subscribe(isAdmin => (this.isAdmin = isAdmin));
  }

  ngAfterViewInit() {
    this.adminSubscription = this.authService.user
      .pipe(
        map(auth => {
          return this.admins.includes(auth.email);
        })
      )
      .subscribe(isAdmin => (this.isAdmin = isAdmin));
  }

  viewAddNewBooking() {
    // this.store.dispatch(new bookingActions.GoToAddBookingView());
    this.router.navigate(['/bookings/add']);
  }

  editCurrentBooking(bookingId) {
    // this.store.dispatch(new bookingActions.GetCurrentBooking(bookingId));
  }

  deleteBooking(bookingId) {
    this.store.dispatch(new bookingActions.DeleteBooking(bookingId));
  }

  viewBookingDetail(booking) {
    this.store.dispatch(new bookingActions.ViewBookingDetail(booking));
    this.router.navigate(['/bookings', `${booking.id}`, 'view']);
  }

  viewAccommodationConfirmation(bookingId) {
    this.store.dispatch(
      new confirmationActions.ViewAccommodationConfirmation(bookingId)
    );
  }

  viewConferenceConfirmation(bookingId) {
    this.store.dispatch(
      new confirmationActions.ViewConferenceConfirmation(bookingId)
    );
  }

  ngOnDestroy() {
    if (this.adminSubscription) {
      this.adminSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/booking-list/booking-list.component.ts